import logo from './logo.svg';
import './App.css';
import TeacherHeader from './Components/teacherHeader';
import Header from './Components/header';
import ClassHeader from './Components/classHeader';
import DayTimetable from './Components/dayTimetable';
import { DatePicker, DatePickerInput } from '@carbon/react';
import React, { useState } from 'react';
import { TeacherLayout } from './Layouts/TeacherLayout';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminLayout } from './Layouts/AdminLayout';
import AuthPage from './Pages/Auth';
import { GRAPHQL_ENDPOINT } from './apollo/client';
import { useEffect } from 'react';
import LogoutPage from './Pages/Logout';
import { PrivateRoute } from './Utils/privateRoute';
import { RoleRoute } from './Utils/roleRpute';
import { StudentLayout } from './Layouts/StudentLayout';
import { useAuth } from './Utils/authProvider';
import Settings from './Pages/settings';
import NotFound from './Pages/NotFound';

function App() {
  const auth = useAuth();

  // Component for redirecting authenticated users from root
  function RootRedirect() {
    if (auth.status === 'loading') return <div>
      Daten werden geladen...
    </div>;
    if (auth.status === 'authenticated') {
      const userRole = auth.user?.role;
      if (userRole === 'admin') {
        // Send admins to the teacher view by default
        return <Navigate to="/teacher" replace />;
      } else if (userRole === 'teacher') {
        return <Navigate to="/teacher" replace />;
      } else if (userRole === 'student') {
        return <Navigate to="/student" replace />;
      }
    }
    return <Navigate to="/auth" replace />;
  }

  return (
    <main className="App bg-gray-0 min-h-screen">
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route element={<PrivateRoute />}>
            {/* Global settings route accessible to all authenticated users */}
            <Route path="/settings" element={<Settings />} />
            
            {/* Logged-in users */}
            <Route element={<RoleRoute allowedRoles={['student']} />}>
              <Route path="/student/*" element={<StudentLayout />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={['teacher']} />}>
              <Route path="/teacher/*" element={<TeacherLayout />} />
            </Route>
            <Route element={<RoleRoute allowedRoles={['admin']} />}>
              <Route path="/admin/*" element={<AdminLayout />} />
            </Route>
            <Route path="/logout" element={<LogoutPage />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
    </main>
  );
}

export default App;
